import React, { useContext } from 'react';
import cn from 'classnames';
import { FlowContext } from '../../core/flow-engine';
import styles from './styles.css';
import BYOPCard from './BYOPCard';
import RDFCard from './RDFCard';
import APPCard from './APPCard';
import MoneyMarketCard from './MoneyMarketCard';

const Contents = () => {
  const {
    flowProps: { noAPPCard }
  } = useContext(FlowContext);

  return (
    <div className={cn('grid-container', { 'single-row': noAPPCard })}>
      <div data-e2e="byop-card" className="grid-item">
        <BYOPCard />
      </div>
      <div data-e2e="rdf-card" className="grid-item">
        <RDFCard />
      </div>

      {noAPPCard || (
        <div data-e2e="app-card" className="grid-item">
          <APPCard />
        </div>
      )}

      <div data-e2e="money-market-card" className="grid-item">
        <MoneyMarketCard />
      </div>
      <style jsx>{styles}</style>
    </div>
  );
};

export default Contents;
